export const abbreviateString = (str: string, n: number) => {
	if (str.length > (2 * n)) {
		return `${str.slice(0, n)}...${str.slice(-n)}`
	}
	return str
}